import React, {useState} from 'react';
import {Field, Table} from 'react-unity';
import Paginator from '../../common/tables/Paginator';
import VirtualMachine from '../../../models/entities/VirtualMachine';
import VirtualMachineTableRow from './VirtualMachineTableRow';

interface VirtualMachinesTableProps {
    virtualMachines: VirtualMachine[];
}

const VirtualMachinesTable = ({virtualMachines}: VirtualMachinesTableProps) => {

	const [pageRow, setPageRows] = useState<VirtualMachine[]>([]);

	const handlePageChange = (page: VirtualMachine[]) => {
		setPageRows(page);
	};

	return (
		<Field>
			<Field.Label>
                Virtual Machines
			</Field.Label>
			<Field.Body>
				<Table
					footer={
						<Paginator
							data={virtualMachines}
							onPageChange={handlePageChange}
						/>
					}
				>
					<Table.Head>
						<Table.Head.Row>
							<Table.Head.Cell> # Id </Table.Head.Cell>
							<Table.Head.Cell> Virtual Machine Request Id </Table.Head.Cell>
							<Table.Head.Cell> Virtual Machine Name </Table.Head.Cell>
							<Table.Head.Cell> Environment </Table.Head.Cell>
							<Table.Head.Cell> Date </Table.Head.Cell>
							<Table.Head.Cell> </Table.Head.Cell>
						</Table.Head.Row>
					</Table.Head>
					<Table.Body>
						{virtualMachines?.length > 0 ?
							virtualMachines.map((virtualMachine) => (
								<VirtualMachineTableRow
									key={virtualMachine.id}
									virtualMachine={virtualMachine}
								/>))
							:
							<Table.Body.Row>
								<Table.Body.Cell
									colSpan={2}
								>
									<i>No virtual machines found.</i>
								</Table.Body.Cell>
							</Table.Body.Row>}
					</Table.Body>
				</Table>
			</Field.Body>
		</Field>
	);
};

export default VirtualMachinesTable;